import type { AnimationKeyframe } from '../types';
import { convertTransformKeyframes } from './transforms';

/**
 * @deprecated Avoid using this function. Use CSS variables instead.
 * Convert and apply a vapor animation definition to
 * an HTML element. Useful for setting styles when wanting
 * to bypass an animation, or to set the styles after an animation
 * has finished instead of leveraging "fill".
 */

export function setStyles(ref: HTMLElement, frame: AnimationKeyframe) {
  const domSafeStyles = omitAnimationStyles(convertTransformKeyframes(frame));
  Object.entries(domSafeStyles).forEach(([key, value]) => {
    // @ts-expect-error FIXME(strictNullChecks)
    ref.style[key] = Array.isArray(value) ? value[value.length - 1] : value;
  });

  return domSafeStyles;
}

/**
 * Return a keyframe definition with styles only.
 * @example
 * const frame = extractAnimationStyles({ x: 0, easing: 'spring' });
 * // frame = { x: 0 }
 */
function omitAnimationStyles(
  keyframes: AnimationKeyframe
): Omit<AnimationKeyframe, 'delay' | 'easing' | 'duration'> {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { delay, easing, duration, ...result } = keyframes;
  return result;
}
